<template>
  <div class="container-fluid pl-5">
    <div class="row">
      <div class="person">
        <img src="../../assets/img/57.png" />
      </div>
      <div class="col">
        <div class="d-flex flex-column bd-highlight client">
          <div class="p-2 bd-highlight ml-auto">
            <h1 class="what">What Our Client Say</h1>
            <div class="d-flex justify-content-end">
              <h1 class="what">About Us!</h1>
            </div>
          </div>
          <div class="p-2 bd-highlight">
            <span class="art">
              <i class="fas fa-question"></i>
            </span>
          </div>
          <div class="p-2 bd-highlight ml-4 try">
            Don't try to be original just try to be good.
            <br />A wonderful serenity has taken possessionof the my
            <br />entire soul, like these sweet mornings of spring
            <br />which I enjoy with my whole heart. I am alone, and
            <br />feel the.
          </div>
          <div class="p-2 bd-highlight pauli ml-5">Pauli Jarvis</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/page1/pauli.vue